/* src/app/views/legal-text-contract/legal-text-contract-argentina/legal-text-contract-argentina.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 0;
  margin: 0 auto 24px;
  width: 100%;
  max-width: 1200px;
}
.image-position {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
}
.ford-protect-logo {
  width: min(380px, 100%);
  height: auto;
  display: block;
}
.page-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 30px 20px 20px 40px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1240px;
}
.contract-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 5px;
}
.contract-information {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
  width: 100%;
}
.contract-information-title {
  font-weight: bold;
  margin-bottom: 14px;
  text-decoration: underline;
}
.contract-information-items {
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.contract-information-items p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
}
.contract-information-items span {
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
  color: #374151;
  word-break: break-word;
  flex: 1;
  min-width: 150px;
}
.editing-list {
  list-style: none;
  padding-left: 0;
  margin-left: clamp(24px, 3vw, 60px);
  margin-right: 20px;
}
.editing-list-item {
  margin-bottom: 15px;
  counter-increment: main-counter;
  position: relative;
  padding-top: 10px;
  padding-left: 1em;
  font-size: 12pt;
  text-align: justify;
}
.editing-list .editing-list-item:before {
  position: absolute;
  left: -2em;
  content: counters(main-counter, ".") ".";
}
.custom-list-roman {
  list-style: none;
  padding-left: 3em;
  margin-left: clamp(16px, 3vw, 40px);
}
.custom-list-roman .li-roman {
  position: relative;
  counter-increment: custom-counter;
  padding-bottom: 2px;
  font-size: 12pt;
  text-align: justify;
  margin-bottom: 10px;
}
.custom-list-roman .li-roman:before {
  position: absolute;
  left: -3em;
  content: "(" counter(custom-counter, upper-roman) ") ";
}
.style-sub-items {
  margin-top: 30px;
  margin-bottom: 30px;
}
.style-sub-items-title {
  margin-left: 0;
  margin-bottom: 20px;
}
.style-sub-items-text {
  margin-left: 30px;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.btn-return {
  width: auto;
  min-width: 137px;
  height: 48px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  color: #046cea;
}
.btn-return-span {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  white-space: nowrap;
}
.btn-return:hover {
  background: #044ea7;
  color: #ffffff;
}
button.btn-return:hover:not(:disabled) .btn-return-span {
  color: #ffffff;
}
.btn-save {
  width: auto;
  min-width: 137px;
  height: 48px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  color: #ffffff;
}
.btn-save-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return i,
.btn-save i {
  color: inherit;
}
.btn-save:disabled,
.btn-return:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  cursor: not-allowed;
  opacity: 1;
}
.btn-save:disabled .btn-save-span,
.btn-return:disabled .btn-return-span,
.btn-save:disabled i,
.btn-return:disabled i {
  color: #6f6f6f;
}
.btn-save:disabled:hover,
.btn-return:disabled:hover {
  background-color: #f5f5f5;
}
.btn-download {
  width: min(400px, 100%);
  height: 48px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 20px;
  margin-right: 50px;
  color: #ffffff;
}
.btn-download-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.btn-download:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
  cursor: not-allowed;
  opacity: 1;
}
.btn-download:disabled .btn-download-span,
.btn-download:disabled i {
  color: #6f6f6f;
}
.btn-download.is-loading {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
}
.btn-download .pi {
  font-size: 18px;
  color: inherit;
}
.btn-download:hover:not(:disabled) {
  background: #044ea7;
}
@media only screen and (max-width: 500px) {
  .contract-information-items {
    grid-template-columns: 1fr;
    row-gap: 4px;
  }
  .btn-return {
    margin-left: 9px;
  }
  .btn-save {
    margin-right: 0;
  }
  .btn-download {
    width: 100%;
    margin-right: 0;
  }
}
/*# sourceMappingURL=legal-text-contract-argentina.component-D4RH4GZ5.css.map */
